export enum WidgetCategory {
	DATA = 'data',
	CONTENT = 'content'
}
